import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getMeBillingInfo,
  upsertMeBillingInfo,
} from "@src/apis/billingInformationApi";
import {
  UpsertBillingInformationPayload,
  ICuratorBillingInformation,
} from "@src/types/billingInformation";

export const useMyBillingInfo = (options?: any) => {
  return useQuery<ICuratorBillingInformation | null>({
    queryKey: ["billingInformation", "me"],
    queryFn: async () => {
      const response = await getMeBillingInfo();
      return response.data.data;
    },
    ...options,
  });
};

export const useUpsertMyBillingInfo = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: UpsertBillingInformationPayload) =>
      upsertMeBillingInfo(payload),
    onSuccess: (response) => {
      queryClient.setQueryData(
        ["billingInformation", "me"],
        response.data.data
      );
      queryClient.invalidateQueries({ queryKey: ["billingInformation", "me"] });
    },
  });
};
